<template>
  <span>
    <div
      class="half-move"
      :class="{
        active: isActive,
        'in-current-line': isInCurrentLine,
        'variation-of-current-move': isVariationOfCurrentMove,
        'variation-1': variationDepth === 1,
        'variation-2': variationDepth === 2,
        'variation-3': variationDepth >= 3,
        'is-masked': isMasked,
      }"
      :style="displayColor && { color: displayColor }"
      @click="!isMasked && $emit('moveSelected')"
    >
      <span v-if="isVariationBegin">(</span>
      <span v-if="shouldShowMoveNumber">
        {{ moveNumber }}{{ isBlack ? "..." : "." }}
      </span>
      <span> {{ san }}</span>
      <span v-if="nag" class="annotation"> {{ nag }}</span>
      <span v-if="isVariationEnd">)</span>

      <span v-if="userScore === 1" class="score-indicator correct">✓</span>
      <span v-if="userScore === -1" class="score-indicator incorrect">✗</span>

      <span v-if="comment && !isMasked" class="annotation icon is-small">
        <i class="fas fa-comment-dots"></i>
      </span>

      <!-- Edit icon -->
      <span
        v-if="!isMasked"
        class="edit-icon-wrapper"
        @click.stop.prevent="$emit('editMove')"
      >
        <b-icon icon="edit" size="is-small" class="edit-icon" />
      </span>
    </div>
  </span>
</template>

<script>
export default {
  name: "HalfMove",

  props: {
    shouldShowMoveNumber: { type: Boolean, default: false },
    moveNumber: { type: Number, required: true },
    isMasked: { type: Boolean, default: false },
    isBlack: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    isInCurrentLine: { type: Boolean, default: false },
    isVariationOfCurrentMove: { type: Boolean, default: false },
    san: { type: String, required: true },
    variationDepth: { type: Number, default: 0 },
    isVariationBegin: { type: Boolean, default: false },
    isVariationEnd: { type: Boolean, default: false },
    displayColor: { type: String, default: null },
    comment: { type: String, default: null },
    nag: { type: String, default: null },
    userScore: { type: Number, default: null },
  },

  emits: ["moveSelected", "editMove"],
};
</script>

<style scoped>
.half-move {
  cursor: pointer;
  border-radius: 6px;
  white-space: nowrap;
  padding: 0.35rem 0.75rem;
  margin: 2px 0;
  min-height: 2rem;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  /* Remove any default borders */
  border: none;
}

.half-move:hover {
  background: #f5f5f5;
  transform: translateY(-1px);
}

.half-move.active {
  background: #e3f2fd;
  font-weight: 600;
  box-shadow: 0 0 0 2px #2196f3;
}

.half-move.in-current-line {
  background: #e3f2fd;
}

.half-move.in-current-line:hover {
  background: #bbdefb;
}

.half-move.variation-of-current-move {
  background: #fff3e0;
  border: 1px dashed #ffe0b2;
}

.half-move.variation-of-current-move:hover {
  background: #ffe0b2;
}

/* Main line moves */
.half-move {
  color: #000;
  font-size: 1em;
}

/* First level variations */
.half-move.variation-1 {
  color: #555;
  font-style: italic;
  font-size: 0.95em;
}

/* Second level variations */
.half-move.variation-2 {
  color: #666;
  font-style: italic;
  font-size: 0.9em;
}

/* Third level and deeper variations */
.half-move.variation-3 {
  color: #777;
  font-style: italic;
  font-size: 0.85em;
}

.annotation {
  margin-left: 0.25rem;
  font-weight: normal;
  opacity: 0.7;
}

/* Add style for masked moves */
.half-move.is-masked {
  cursor: default;
}

.half-move.is-masked:hover {
  background: transparent;
  transform: none;
}

.edit-icon-wrapper {
  position: absolute;
  right: 0.25rem;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 0.2s ease;
  cursor: pointer;
  padding: 4px;
  z-index: 1;
}

.half-move:hover .edit-icon-wrapper {
  opacity: 1;
}

.edit-icon {
  color: #666;
}

.score-indicator {
  margin-left: 0.25rem;
  font-weight: bold;
}

.score-indicator.correct {
  color: #4caf50;
}

.score-indicator.incorrect {
  color: #f44336;
}
</style>
